import { resourceReducer } from 'redux-resource';

const addresses = resourceReducer('addresses');
export default addresses;

export const getSaveAddressStatus = (state) =>
  state.requests.save && state.requests.save.status;
export const getCreateAddressStatus = (state) =>
  state.requests.create && state.requests.create.status;
